import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isTokenExpired } from './tokenUtils';
import { isClientRole } from './roleUtils';

export default function RevenueCycleRoute({ children }) {
  const { token, user } = useAuth();
  if (!token || isTokenExpired(token)) return <Navigate to="/login" replace />;
  if (isClientRole(user?.role)) return <Navigate to="/client" replace />;
  return children;
}
